import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getPlatformFeatureFlags } from './getFeatureFlags';
export var getSrcUrl = function getSrcUrl(tunnels, extensionResource, defaultUrl) {
  var matchTunnel = tunnels.find(function (tunnel) {
    return tunnel.resourceKey === extensionResource;
  });
  var platformFeatureFlags = getPlatformFeatureFlags();
  var queryParams = new URLSearchParams(_objectSpread(_objectSpread({}, platformFeatureFlags.length > 0 ? {
    platformFeatureFlags: platformFeatureFlags.join(',')
  } : {}), matchTunnel ? {
    hostname: window.location.hostname
  } : {})).toString();
  var query = queryParams ? "?".concat(queryParams) : '';
  if (matchTunnel) {
    return "".concat(matchTunnel.tunnelUrl).concat(query);
  }
  return "".concat(defaultUrl).concat(query);
};